import type { PortalUser } from "@/app/models";
import { PORTAL_USER_TYPE } from "@/app/models";
import {
  getAdminNavigation,
  getCancelledPatientNavigation,
  getCoachingNavigation,
  getPatientNavigation,
} from "../navigation";

export const getNavigation = (user: PortalUser | null) => {
  const subscriptions = user?.subscriptions ?? [];

  if (!subscriptions.length && user?.type !== PORTAL_USER_TYPE.ADMIN) {
    return getCancelledPatientNavigation();
  }

  switch (user?.type) {
    case PORTAL_USER_TYPE.ADMIN:
      return getAdminNavigation();

    case PORTAL_USER_TYPE.PATIENT:
      return getPatientNavigation().filter((navItem) => {
        return subscriptions.some((subscription) => {
          const hasRequiredCategory = navItem.activeCategories.includes(
            subscription.product.category.slug,
          );

          const hasRequiredVendor =
            !navItem.vendors || navItem.vendors.includes(subscription.vendor);

          return hasRequiredCategory && hasRequiredVendor;
        });
      });

    case PORTAL_USER_TYPE.COACHING:
      return getCoachingNavigation();
    default:
      return [];
  }
};
